// 广告配置文件

export const adConfig = {
  // 首页瀑布流广告
  homeCards: {
    enabled: true,
    noAdRows: 4, // 前4行不显示广告（16个位置）
    adFrequency: 3, // 每3行插入一个广告（12个位置为一个区间）
    randomPosition: true // 随机位置插入
  },

  // 分类页面瀑布流广告
  categoryCards: {
    enabled: true,
    noAdRows: 4, // 前4行不显示广告（16个位置）
    adFrequency: 3, // 每3行插入一个广告（12个位置为一个区间）
    randomPosition: true // 随机位置插入
  },

  // 模型加载广告
  modelLoading: {
    enabled: true,
    autoCloseDelay: 5000 // 5秒后自动关闭
  },

  // 右下角动态广告
  dynamicAd: {
    enabled: false // 暂时禁用，使用小猫动画
  },

  // 相关模型广告
  relatedModels: {
    enabled: true,
    randomPosition: true,
    maxPosition: 4 // 在前4个相关模型中随机插入
  },

  // Banner广告
  banner: {
    enabled: true
  },

  // 模型介绍下方Banner广告
  modelInfoBanner: {
    enabled: true,
    adData: {
      image: 'https://picsum.photos/1200/150?random=99',
      title: '专业3D建模课程 - 零基础入门',
      company: 'MetaHub学院',
      link: '#'
    }
  },

  // 评论底部Banner广告
  commentBottomBanner: {
    enabled: true,
    adData: {
      image: 'https://picsum.photos/1200/150?random=100',
      title: '3D模型市场 - 海量优质资源',
      company: 'MetaHub商城',
      link: '#'
    }
  },

  // 我的模型页面底部Banner广告
  myModelBottomBanner: {
    enabled: true,
    adData: {
      image: 'https://picsum.photos/1200/150?random=101',
      title: '提升模型质量 - 专业建模工具推荐',
      company: 'MetaHub工具',
      link: '#'
    }
  },

  // 模型上传页面底部Banner广告
  uploadPageBottomBanner: {
    enabled: true,
    adData: {
      image: 'https://picsum.photos/1200/150?random=102',
      title: '模型上传技巧 - 让您的作品更受欢迎',
      company: 'MetaHub学院',
      link: '#'
    }
  },

  // 我的收藏页面底部Banner广告
  myCollectBottomBanner: {
    enabled: true,
    adData: {
      image: 'https://picsum.photos/1200/150?random=103',
      title: '发现更多优质模型 - 探索精选资源',
      company: 'MetaHub精选',
      link: '#'
    }
  },

  // 浏览记录页面底部Banner广告
  historyBottomBanner: {
    enabled: true,
    adData: {
      image: 'https://picsum.photos/1200/150?random=104',
      title: '继续探索 - 为您推荐相似模型',
      company: 'MetaHub推荐',
      link: '#'
    }
  },

  // 个人中心页面底部Banner广告
  userCenterBottomBanner: {
    enabled: true,
    adData: {
      image: 'https://picsum.photos/1200/150?random=105',
      title: '完善个人资料 - 获得更多关注',
      company: 'MetaHub社区',
      link: '#'
    }
  },

  // 下载弹窗广告
  downloadAd: {
    enabled: false, // 暂时禁用
    countdown: 5 // 5秒倒计时
  }
}

// 示例广告数据
const sampleAds = [
  {
    id: 1,
    image: 'https://picsum.photos/400/300?random=1',
    title: '专业3D建模工具 - 限时优惠',
    company: 'MetaHub工具',
    link: '#'
  },
  {
    id: 2,
    image: 'https://picsum.photos/400/300?random=2',
    title: '高品质纹理素材库',
    company: 'TexturePro',
    link: '#'
  },
  {
    id: 3,
    image: 'https://picsum.photos/400/300?random=3',
    title: 'AI辅助建模服务',
    company: 'AI Modeler',
    link: '#'
  },
  {
    id: 4,
    image: 'https://picsum.photos/400/300?random=4',
    title: '3D渲染农场 - 按需计费',
    company: 'RenderCloud',
    link: '#'
  },
  {
    id: 5,
    image: 'https://picsum.photos/400/300?random=5',
    title: '模型优化与压缩工具',
    company: 'OptimizePro',
    link: '#'
  }
]

// 获取随机广告
export const getRandomAd = (type = 'homeCard') => {
  const randomIndex = Math.floor(Math.random() * sampleAds.length)
  return sampleAds[randomIndex]
}

// 获取多个随机广告
export const getRandomAds = (count = 1) => {
  const shuffled = [...sampleAds].sort(() => 0.5 - Math.random())
  return shuffled.slice(0, count)
}

